module.exports = __webpack_public_path__ + "img/request-status.faeba7e6.svg";